export default "__VITE_ASSET__Ctd$FwBG__"